!function(window) {

function centerToActive(){
	//if(document.getElementById('secondaryMenu')) {
		if(document.querySelector("#secondaryMenu")){
			let scrollFromLeft = 0;
			const clientWidth = document.documentElement.clientWidth;
			const activeElement = document.querySelector("#secondaryMenu .bs-level1-open").getBoundingClientRect();
			scrollFromLeft = activeElement.right - clientWidth / 2 - activeElement.width/2;
			document.querySelector("#secondaryMenu ul").scrollTo(scrollFromLeft, 0);
		}
	//}
}
//centerToActive();

window.centerToActive = centerToActive;
}(window);